import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';
import type { EnumValue } from '@linc-technologies/linced-common/enums/base-enum';
import type StreamSource from '@linc-technologies/linced-common/enums/stream-source';

// Proto: media.Video.
export default class Video extends Fragment {
  declare [Type]: 'media/video';

  @attr('number', { defaultValue: 0 })
  declare streamSource: EnumValue<typeof StreamSource> | 0;

  @attr('string', { defaultValue: '' })
  declare streamId: string;

  @attr('boolean', { defaultValue: false })
  declare streamProcessed: boolean;

  @attr('string', { defaultValue: '' })
  declare poster: string;
}
